// extracted by mini-css-extract-plugin
export var disabled = "_2l-5";
export var fileName = "_2l-b";
export var filePreview = "_2l-4";
export var hoverFilter = "_2l-6";
export var imageButton = "_2l-3 _2l-6";
export var imageButtonContainer = "_2l-2";
export var input = "_2l-7";
export var removeButton = "_2l-0";
export var removeButtonFile = "_2l-1";
export var spinner = "_2l-9";
export var spinnerContainer = "_2l-8";
export var videoContainer = "_2l-a _2l-6";